import { Search } from "lucide-react"
import { Input } from "@/components/ui/input"

export function GlobalSearch() {
  return (
    <div className="relative w-full max-w-md">
      <Search className="pointer-events-none absolute left-3.5 top-1/2 size-4 -translate-y-1/2 text-slate-400" />
      <Input
        type="search"
        disabled
        placeholder="Szukaj klientów, umów, dokumentów…"
        className="h-9 pl-10 pr-16 rounded-full bg-slate-100 border-transparent placeholder:text-slate-400 focus-visible:bg-white focus-visible:border-slate-300 focus-visible:ring-slate-300/40"
      />
      <kbd className="pointer-events-none absolute right-2.5 top-1/2 hidden -translate-y-1/2 select-none items-center gap-1 rounded-md border border-slate-200 bg-white px-1.5 py-0.5 font-mono text-[10px] font-semibold text-slate-500 shadow-xs sm:inline-flex">
        <span className="text-xs">⌘</span>K
      </kbd>
    </div>
  )
}
